module.exports = __webpack_public_path__ + "img/partners.af424745.png";